// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1NXB3","boxCategory":"styles_boxCategory__3FL6T","imgBox":"styles_imgBox__XGIn1","textBox":"styles_textBox__gcniL","Boxtext":"styles_Boxtext__2xkcU"};